import BusEvent from "common/services/BusEvent"
import { db } from "../../common/config/Firebase"

const ticketsCollection = db.collection('tickets')

const updateTicketUseCase = (ticket, oldTicket) => {
    let ticketDate = ticket.ticketDate instanceof Date 
        ? ticket.ticketDate.getTime() 
        : ticket.ticketDate
    

    ticketDate = ticketDate || new Date().getTime()

    BusEvent.publish(BusEvent.UPDATE_TICKET, { ticket, oldTicket })

    return ticketsCollection
        .doc(ticket.id)
        .set({ ...ticket, ticketDate })
}

export default updateTicketUseCase